export const mobileMenuConfig = [
  {
    id: 1,
    to: '/',
    text: 'home',
  },
  {
    id: 2,
    to: '/professional',
    text: 'professional',
  },
  {
    id: 3,
    to: '/videoGames',
    text: 'video games',
  },
  {
    id: 4,
    to: '/tabletopGames',
    text: 'tabletop games',
  },
  {
    to: '/workshops',
    text: 'workshops',
    id: 5,
  },
  {
    id: 6,
    to: '/media',
    text: 'media',
  },
  {
    id: 7,
    to: '/achievements',
    text: 'achievements',
  },
];
